import React from 'react';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

const CarFaxChipField = ({ record }) => {
  const {
    date,
    type,
    id,
    mileage,
    completed_services,
    recall_information,
  } = record;

  const services = completed_services ? completed_services.join('\n') : '';
  const recalls = recall_information ? recall_information.join('\n') : '';

  const backgroundColor = type === 'service' ? '#479BA0' : '#F18487';
  const tooltipText = `Mileage: ${mileage}\n\n${services}\n${recalls}`;

  return (
    <Tooltip
      title={<div style={{ whiteSpace: 'pre-line' }}>{tooltipText}</div>}
      key={id}
    >
      <Chip
        label={date}
        style={{ fontSize: '11px', backgroundColor, cursor: 'pointer' }}
      />
    </Tooltip>
  );
};

export default CarFaxChipField;
